<template>
  <div>
    <div class="containerView">
<!--      <div class="rowFlex alignitems jus-btw p-tb-16">-->
<!--        <div class="searchView" @click.stop="onSearch">-->
<!--          <img src="@/assets/image/statisticManage/search@3x.png" class="imgView48" />-->
<!--          <div class="searchInfoView one-text" :style="{color:searchInfoName ? '#3B3A38' : '#898887'}">{{searchInfoName ? searchInfoName : '请输入成员昵称'}}</div>-->
<!--        </div>-->
<!--        <img v-if="filterItems && Object.keys(filterItems).length > 0" src="@/assets/image/statisticManage/filtered@3x.png" class="imgView48" @click="handleFilter"/>-->
<!--        <img v-else src="@/assets/image/statisticManage/filter@3x.png" class="imgView48" @click="handleFilter"/>-->
<!--      </div>-->
      <div class="rowFlex alignitems jus-btw">
        <van-search
            v-model="searchInfo"
            placeholder="请输入群名称"
            shape="round"
            background="#FFFFFF"
            class="searchView"
            @search="onSearch"
        >
          <template #left-icon style="display: flex;align-items: center;margin-right: 4px;">
            <img src="@/assets/image/statisticManage/search@3x.png" class="imgView48"/>
          </template>
        </van-search>
        <div class="btn" @click.stop="onSearch">搜索</div>
      </div>
      <div class="p-tb-12 rowFlex alignitems">
        <div :class="['tabOption ',currentTab == item.id ? 'activeTab' : 'normalTab']" v-for="(item,index) in tabList" :key="index" @click.stop="handleChangeTab(item)">{{item.title}}</div>
      </div>
    </div>
    <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
    >
      <van-list
          class="listView"
          v-model="loading"
          :finished="finished"
          :error="error"
          finished-text="没有更多信息了～"
          error-text="数据加载失败，请重试"
          @load="onLoad"
      >
        <div class="listItem" v-for="(item,index) in list" :key="index" @click.stop="handleGroupDetail(item)">
          <div class="contentView">
            <div class="itemTopView">
              <div class="leftView">
                <div class="title">{{item.groupName}}</div>
              </div>
              <div class="rightView">
                <div class="btn">查看群画像</div>
                <img src="@/assets/image/statisticManage/next@3x.png" class="imgView24" />
              </div>
            </div>
            <div class="itemMiddle">
              <div class="middleTitle">群主名称： </div>
              <div class="rowFlex alignitems">
                <img :src="item.groupMasterHandPic ? item.groupMasterHandPic : defaultHeadImg" class="imgView36 radius50 m-r-12"/>
                <div class="middleInfo">{{item.groupMasterName}}</div>
                <div v-if="item.hasJoin == 1" class="inView">我在群中</div>
              </div>
            </div>
            <div class="itemMiddle">
              <div class="middleTitle">群员总数： </div>
              <div class="rowFlex alignitems">
                <div class="middleInfo">{{item.groupPeopleCount}}</div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import utils from "@/utils/common";
import http from "@/utils/axios";
export default ({
  props:{
    memberId:{
      type:String,
      default:() => {
        return ''
      }
    },
    corpId:{
      type:String,
      default:() => {
        return ''
      }
    },
    wxUserId:{
      type:String,
      default:() => {
        return ''
      }
    }
  },
  data() {
    return {
      defaultHeadImg:require('@/assets/image/statisticManage/defaultHead@3x.png'),
      list: [],
      page: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      searchInfo:'',
      filterItemIds:{},
      filterItemNames:{},
      filterItems:{},
      customeTime:'',
      searchInfoName:'',
      selectItemIds:[],
      selectItems:[],
      currentTab:0,
      tabList:[
        {
          id:0,
          title:'全部群'
        },
        {
          id:1,
          title:'我所在群'
        }
      ]
    }
  },
  created() {
    // this.$loading.hide();
    // this.getDataList()
  },
  mounted() {
    if(!utils.isNullData(localStorage.getItem('selectItemIds'))){
      let selectItemIds = JSON.parse(localStorage.getItem('selectItemIds'))
      let selectItems = JSON.parse(localStorage.getItem('selectItems'))
      this.selectItemIds = selectItemIds
      this.selectItems = selectItems
      let names = selectItems.map((item) => {
        return item.name
      })
      this.searchInfo = selectItemIds.join(',')
      this.searchInfoName = names.join(',')
      localStorage.removeItem('selectItemIds')
      localStorage.removeItem('selectItems')
    }
  },
  methods:{
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      this.refreshing = true
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.error = false;
      this.page = 1
      this.total = 0
      this.onLoad();
    },
    // 列表加载数据
    onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      }
      if (this.list.length > 0 && this.list.length >= this.total) {
        this.finished = true
        return
      }
      this.getDataList()
    },
    /**
     * 查询群成员信息
     * */
    getDataList(){
      this.$loading.hide()
      this.loading = true
      http({
        url: "order/dmp/dispatch/memberpush/BsEnterpriseWechatUser/getUserGroupList",
        method: "post",
        parmes: {
          groupName:this.searchInfo,
          searchType:this.currentTab,
          userId:this.wxUserId,
          pageIndex:this.page,
          pageSize:this.pageSize
        }
      }).then(rps => {
        if (rps.code == 200) {
          let data = rps.data;
          this.list = this.list.concat(data.list);
          this.page++
          this.total = data.total
          this.loading = false;
          if (this.list.length >= this.total) {
            this.finished = true;
          }
        }else{
          this.loading = false;
          this.error = true;
          this.$toast('请求异常，请稍后重试')
        }
        this.$loading.hide();
      }).catch(() => {
        this.$loading.hide();
        this.loading = false;
        this.error = true;
        this.$toast('请求失败，请稍后重试')
      });
    },
    /**
     * 格式化数据
     */
    getTransformData(data, defaultValue = '') {
      if (utils.isNullData(data)) {
        return defaultValue
      }
      return data;
    },
    // 点击筛选
    handleFilter() {
      this.showFilter = true
    },
    // 关闭筛选框
    handleClose() {
      this.showFilter = false
    },
    // 筛选确认
    handleConfirm(selectItemIds,selectItems,customeTime) {
      this.showFilter = false
      this.filterItemIds = selectItemIds
      this.filterItems = selectItems
      this.customeTime = customeTime
    },
    // 搜索
    onSearch() {
      // this.list = []
      // this.page = 1
      // this.total = 0
      // this.getDataList()
      this.onRefresh()
      // localStorage.setItem('currentTab','member')
      // this.$router.push({
      //   path:'/searchPage',
      //   query:{
      //     pageType:'memberList',
      //     placeholder:'请输入成员昵称'
      //   }
      // })
    },
    handleChangeTab(item){
      this.currentTab = item.id
      // this.list = []
      // this.page = 1
      // this.total = 0
      // this.getDataList()
      this.onRefresh()
    },
    /**
     * 查看群画像
     * */
    handleGroupDetail(item){
      this.$router.push({
        path:'/groupStatisticDetail',
        query:{
          id:item.groupId,
          corpId:this.corpId
        }
      })
    }
  }
})
</script>
<style lang="less" scoped>
@import url("../../style/index.css");
.containerView {
  width: calc(100% - 48px);
  padding: 16px 24px;
  background: #FFFFFF;
  .searchView{
    display: flex;
    align-items: center;
    //justify-content: space-between;
    width: calc(85% - 32px);
    //padding: 8px 16px;
    padding: 0 0;
    height: 64px;
    background: #F6F6F6;
    border-radius: 32px;
    margin-left: 4px;
    font-size: 28px;
    font-weight: 400;
    color: #898887;
    line-height: 40px;
    .searchInfoView{
      font-size: 28px;
      font-weight: 400;
      color: #898887;
      line-height: 40px;
      margin-left: 4px;
      width: calc(100% - 52px);
    }
  }
  .btn{
    height: 64px;
    background: #4466F5;
    border-radius: 40px;
    padding: 0 26px;
    font-size: 28px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .tabOption{
    font-size: 24px;
    font-weight: 400;
    line-height: 33px;border-radius: 8px;
    padding: 11px 0;
    width: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
  }
  .normalTab{
    color: #62615F;
    background: #F6F6F6;
    border: 2px solid #F6F6F6;
  }
  .activeTab{
    background: rgba(68,102,245,0.1);
    border-radius: 8px;
    border: 2px solid #4466F5;
    color: #4466F5;
  }
}
.listView{
  padding: 16px 24px;
  background: #F2F2F2;
}
.listItem{
  padding: 24px 24px;
  background: #FFFFFF;
  margin-bottom: 16px;
  .contentView{
    display: flex;
    flex-direction: column;
    width: 100%;
    .itemTopView{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;
      .leftView{
        width: calc(100% - 200px);
        display: flex;
        align-items: center;
        .title{
          font-size: 32px;
          font-weight: 500;
          color: #3B3A38;
          line-height: 40px;
          width: 100%;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
      .rightView{
        display: flex;
        align-items: center;
        .btn{
          font-size: 24px;
          font-weight: 400;
          color: #4466F5;
          line-height: 32px;
        }
      }
    }
    .itemMiddle{
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      .middleTitle{
        font-size: 28px;
        font-weight: 400;
        color: #8C94A0;
        line-height: 36px;
      }
      .middleInfo{
        font-size: 28px;
        font-weight: 500;
        color: #26282A;
        line-height: 36px;
      }
      .inView{
        background: #F08E3C;
        border-radius: 4px;
        margin-left: 12px;
        font-size: 18px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 26px;
        padding:6px 6px;
      }
    }
  }
}
.van-search .van-cell {
  display: flex;
  align-items: center;
  padding: 0 0;
}

/deep/ .van-search__content--round {
  border-radius: 32px;

  .van-field__left-icon {
    display: flex !important;
    align-items: center !important;
    margin-right: 4px !important;
  }
}

.van-search__content {
  background: #F6F6F6 !important;
  height: 100% !important;
}
/deep/ .van-field__control{
  width: calc(100% - 64px);
}
</style>
